module.exports = __webpack_public_path__ + "static/b1-mktg-908c73159857dee6839ed7fe42f3b8b1.jpg";